import React, { useEffect, useState } from 'react';
import { Form, Checkbox, Collapse, Input, Select } from 'antd';
import { createUseStyles } from 'react-jss'

import Collection from '../../../common/Collection'

import { POST, errorCatch, deleteInArray, JSX, GET, READ, useUserContext } from 'fennec-ui'
import NovieYacheikiVKomissiyah from '../../forms/NovieYacheikiVKomissiyah'
import NoviePromokodiVYacheikakh from '../../forms/NoviePromokodiVYacheikakh'
import IzmenitPromokodiVYacheikakh from '../../forms/IzmenitPromokodiVYacheikakh'
import InputWithSearchModal from '../../components/InputWithSearchModal';
import UserFilter from '../UserFilter';
import UserSelector from '../UserSelector';
import { isAnyFederationAdministrator } from '../../../common/Tool';
const { Panel } = Collapse;
const { Option } = Select;

const useStyles = createUseStyles({
    tabs: {
        '& .ant-tabs-nav': {
            margin: "0 0 6px 0"
        },
        '& .ant-tabs-tab + .ant-tabs-tab': {
            margin: "0 0 0 20px"
        },
        '& .ant-tabs-nav .ant-tabs-tab': {
            padding: "5px 0",
            fontSize: "13px"
        }
    },
    collapse: {
        '& .ant-collapse-content > .ant-collapse-content-box': {
            padding: "0px"
        },
        '&.ant-collapse > .ant-collapse-item > .ant-collapse-header .ant-collapse-arrow': {
            top: "-2px",
            left: "9px"
        },
        '&.ant-collapse > .ant-collapse-item > .ant-collapse-header': {
            padding: "4px 10px",
            paddingLeft: "25px",
            fontWeight: "300"
        },
        '&.ant-collapse .filtered .filtered-header-wrapper .ant-card-body': {
            padding: "7px",
        }
    },
    fieldName: {
        fontWeight: "300"
    },
    fieldValue: {
        fontStyle: "italic",
        color: "black",
        fontWeight: "300"
    }
})

export default function IzmenitYacheikiUslugi(props) {
    const classes = useStyles()
    const { auth, object, form, sourceKey, queryFilterContext, soruceID } = props;
    const [prilozhenie, setPrilozhenie] = useState();
    const user = useUserContext();

    useEffect(() => {
        form.resetFields();
        READ(auth, "TipiPrilozhenii", ({ data }) => {
            setPrilozhenie(data)
        }, errorCatch)
    }, []);

    const prilozhenieOptions = prilozhenie?.map((i) => <Option key={i.ID} label={i.name} value={i.ID}>{i.name}</Option>);

    return (
        <>
            <Form
                form={form}
                onFinish={props.submit}
                labelAlign={"left"}
                layout={"vertical"}
                initialValues={{
                    ...object,
                    artist: object?.artist?.user
                }}
            >
                <Form.Item label="Название"
                    name="nazvanie"
                    rules={[{ required: true, message: 'Пожалуйста, укажите промокод!' }]}
                >
                    <Input />
                </Form.Item>
                <Form.Item label="Описание"
                    name="opisanie"
                    rules={[{ required: false, message: 'Пожалуйста, укажите описание!' }]}
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    name="zaregistrirovanniiPolzovatel"
                    valuePropName="checked"
                >
                    <Checkbox>
                        Зарегистрированный пользователь
                    </Checkbox>
                </Form.Item>
                {/* <Form.Item
                    name="registratsiyaKollektiva"
                    valuePropName="checked"
                >
                    <Checkbox>
                        Регистрация коллектива
                    </Checkbox>
                </Form.Item> */}
                <Form.Item label="Регистрация на соревнования"
                    name="prilozhenieID"
                    rules={[{ required: false, message: 'Пожалуйста, укажите регистрацию на соревнования!' }]}
                >
                    <Select
                        allowClear
                        showSearch
                        optionFilterProp="children"
                        optionLabelProp="label"
                        filterOption={(input, option) =>
                            option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                        filterSort={(optionA, optionB) =>
                            optionA.label.toLowerCase().localeCompare(optionB.label.toLowerCase())
                        }
                    >
                        {prilozhenieOptions}
                    </Select>
                </Form.Item>

                <Form.Item
                    name="zritel"
                    valuePropName="checked"
                >
                    <Checkbox>
                        Зритель
                    </Checkbox>
                </Form.Item>
                <Form.Item
                    name="neUchitivatVAgentskikh"
                    valuePropName="checked"
                >
                    <Checkbox>
                        Не учитывать в агентских
                    </Checkbox>
                </Form.Item>
                {(isAnyFederationAdministrator(user)) && <Form.Item
                    name="neUchitivatVOborotakh"
                    valuePropName="checked"
                >
                    <Checkbox>
                        Не учитывать в оборотах
                    </Checkbox>
                </Form.Item>}
                <Form.Item
                    name="notActive"
                    valuePropName="checked"
                >
                    <Checkbox>
                        Неактивная услуга
                    </Checkbox>
                </Form.Item>
                <Form.Item
                    name={"artist"}
                    label={"Артист"}
                    rules={[{ required: false, message: 'Укажите aртистa!' }]}
                >
                    <InputWithSearchModal valueAsObject={true} auth={auth} title={"Поиск пользователя"} url={"/api/find/finduserfilter"} object={{}}
                        searchForm={UserFilter}
                        selectForm={UserSelector} />
                </Form.Item>
            </Form>
            <Collapse className={classes.collapse} accordion>
                {/* <Panel header="Комиссии" key="service">
                    <Collection
                        auth={auth}
                        noPrint={true}
                        noPagination={false}
                        size="small"

                        // selection="checkbox" // checkbox | radio

                        source={"/api/komissiivyacheikakh/byusl/" + object.ID}
                        // data={[]}

                        filters={() => [
                            {
                                name: 'Активная',
                                value: item => !item.komissiyaPartneram.notActive, //(item.notActive) ? "Да" : "Нет",
                                field: "active",
                                type: "bool",
                                filter: true
                            },
                            {
                                name: 'Неактивная',
                                value: item => item.komissiyaPartneram.notActive, //(item.notActive) ? "Да" : "Нет",
                                field: "notActive",
                                type: "bool",
                                filter: true
                            }
                        ]}
                        columns={() => [
                            {
                                title: 'Название',
                                render: (text, record) => {
                                    return (record.komissiyaPartneram.sutKomissii);
                                }
                            }
                        ]}
                        collectionActions={() => [
                            {
                                action: {
                                    method: "POST",
                                    path: "/api/komissiivyacheikakh/new",
                                    mutation: "update",
                                    onValues: (values) => {
                                        return { ...values, yacheikaVUslugeID: object.ID }
                                    },
                                    onClose: ({ close }) => close(),
                                },
                                title: "Новая комиссия",
                                modal: {
                                    width: "40%",
                                    minWidth: "400px",
                                    title: "Выбор комиссии",
                                },
                                form: NovieYacheikiVKomissiyah,
                                sourceKey: sourceKey,
                                soruceID: soruceID,
                                queryFilterContext: queryFilterContext,
                                parentObject: object
                            }
                        ]}
                        modelActions={(item) => [
                            // Примеры:
                            // {
                            //     title: "Изменить",
                            //     modal: {
                            //         minWidth: "300px",
                            //         title: "Изменить промокод",
                            //     },
                            //     form: IzmenitPromokodi,
                            //     action: {
                            //         method: "POST",
                            //         path: "/api/promokodi/update",
                            //         mutation: "update",
                            //         onValues: (values, context) => {
                            //             return { ...values, ID: item.ID }
                            //         },
                            //         onClose: ({unlock, close}, context) => close()
                            //     },
                            // },
                            {
                                title: "Удалить",
                                action: (values, unlock, close, { collection, setCollection }) => {
                                    // тут можно как угодно изменить values и вызвать unlock, или close если использовалась форма
                                    // или проигнорировать values, например если это функция удаления из коллекции элемента item (он же record из таблицы)
                                    POST(auth, '/api/komissiivyacheikakh/delete', { ...item },
                                        () => setCollection(deleteInArray(collection, item)), errorCatch
                                    );
                                    // return ({collection, setCollection})=>{
                                    //     // тут можно установить полученное значение во внутреннее состояние или вызвать dispatch
                                    //     // после синхронных вызовов выше
                                    //     setCollection(deleteInArray(collection, item));
                                    // }
                                },
                                // action: {
                                //     method: "POST",
                                //     path: "/api/komissiivyacheikakh/delete",
                                //     mutation: "delete",
                                //     onValues: (values, context) => {
                                //         return { ...item }
                                //     },
                                //     onData: (values, context) => { 
                                //         console.log("onData");
                                //         // т.к. сервер на запрос удаления не высылает никакие данные в ответе, то эмитируем получение данных функцией onData, 
                                //         // в которой возвращаем удаляемый из коллекции элемент, а параметр values который должен содержать данные пришедшие от 
                                //         // сервера в этом случае пустой
                                //         return { ...item }
                                //     },
                                // },
                            }
                        ]}
                    />
                </Panel> */}
                <Panel header="Промокоды" key="promo">
                    <Collection
                        auth={auth}
                        noPrint={true}
                        noPagination={false}
                        size="small"
                        source={"/api/promokodivyacheikakh/byuls/" + object.ID}
                        filters={() => [
                            {
                                name: 'Процент',
                                value: item => item.protsentObshcheiSummiUslugiNaMeropriyatii,
                                field: "protsentObshcheiSummiUslugiNaMeropriyatii",
                                type: "string",
                                sort: true
                            },
                            {
                                name: 'Сумма',
                                value: item => item.rubleiOtObshcheiSummiUslugiNaMeropriyatii,
                                field: "rubleiOtObshcheiSummiUslugiNaMeropriyatii",
                                type: "string",
                                sort: true
                            }
                        ]}
                        columns={() => [
                            {
                                title: 'Название',
                                render: (text, record) => {
                                    return (record.promokod.promokod);
                                }
                            },
                            {
                                title: 'Активный',
                                render: (text, record) => {
                                    return (!record.notActive) ? "Да" : "Нет";
                                }
                            },
                            {
                                title: 'Процент',
                                render: (text, record) => {
                                    return (record.protsentObshcheiSummiUslugiNaMeropriyatii);
                                }
                            },
                            {
                                title: 'Сумма',
                                render: (text, record) => {
                                    return (record.rubleiOtObshcheiSummiUslugiNaMeropriyatii);
                                }
                            }
                        ]}
                        collectionActions={() => [
                            {
                                action: {
                                    method: "POST",
                                    path: "/api/promokodivyacheikakh/new",
                                    mutation: "update",
                                    onValues: (values) => {
                                        return { ...values, yacheikaUslugiID: object.ID }
                                    },
                                    onClose: ({ close }) => close(),
                                },
                                title: "Новый промокод",
                                modal: {
                                    width: "40%",
                                    minWidth: "400px",
                                    title: "Выбор промокода",
                                },
                                form: NoviePromokodiVYacheikakh,
                                parentObject: object,
                                soruceID: soruceID,
                                sourceKey: sourceKey,
                                queryFilterContext: queryFilterContext
                            }
                        ]}
                        modelActions={(item) => [
                            {
                                title: "Изменить",
                                modal: {
                                    minWidth: "300px",
                                    title: "Изменить промокод в услуге",
                                },
                                action: {
                                    method: "POST",
                                    path: "/api/promokodivyacheikakh/update",
                                    mutation: "update",
                                    onValues: (values) => {
                                        return { ...values, ID: item.ID }
                                    },
                                    onClose: ({ close }) => close()
                                },
                                form: IzmenitPromokodiVYacheikakh,
                                sourceKey: sourceKey,
                                queryFilterContext: queryFilterContext,
                                parentObject: object,
                            },
                            {
                                title: "Удалить",
                                action: (values, unlock, close, { collection, setCollection }) => {
                                    POST(auth, '/api/promokodivyacheikakh/delete', { ...item },
                                        () => setCollection(deleteInArray(collection, item)), errorCatch
                                    );
                                },
                            }
                        ]}
                    />
                </Panel>
            </Collapse>
        </>
    );
}
